import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const PassportDetails = (props) => {
	const { onChangeHandler, SelectedFormState, interviewDetails, DateChangeHandler, dateHandlerString } = props;
	return (
		<div>
			<div className="appDivider" />
			<h5 style={{ color: '#666' }} className="">
				Passport Details
			</h5>
			<div className="appDivider" />
			<div className='container'>

				<div className='row'>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel text">
										Passport No
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.PassportNo}
										name="PassportNo"
										type="text"
										maxLength="20"
										disabled={interviewDetails.editable === false ? true : false}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel text">
										Issued Date
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<DatePicker
										selected={SelectedFormState.PassportIssuedDate}
										showMonthDropdown
										showYearDropdown
										dateFormat="dd-MMM-yyyy"
										className="form-control z-depth-3"
										dropdownMode="select"
										autoComplete="off"
										placeholderText="dd-mmm-yyyy"
										maxDate={new Date()}
										disabled={interviewDetails.editable === false ? true : false}
										onChange={(e)=>dateHandlerString(e,"PassportIssuedDate")}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel text">
										Date of Expiry
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<DatePicker
										selected={SelectedFormState.PassportDateOfExpiry}
										showMonthDropdown
										showYearDropdown
										dateFormat="dd-MMM-yyyy"
										className="form-control z-depth-3"
										dropdownMode="select"
										autoComplete="off"
										placeholderText="dd-mmm-yyyy"
										// maxDate={new Date()}
										disabled={interviewDetails.editable === false ? true : false}
										onChange={(e)=> dateHandlerString(e,"PassportDateOfExpiry")}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel text">
										Status
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.PassportStatus}
										name="PassportStatus"
										type="text"
										maxLength="100"
										disabled={interviewDetails.editable === false ? true : false}
									/>
								</div>
							</div>
						</div>
					</div>

					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel text">
										Comments
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.PassportComments}
										name="PassportComments"
										type="text"
										maxLength="100"
										disabled={interviewDetails.editable === false ? true : false}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="appDivider" />
			<h5 style={{ color: '#666' }} className="" >
				Visa Details
			</h5 >
			<div className="appDivider" />
			<div className='container'>
				<div className='row'>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Visa No
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.visaNo}
										name="visaNo"
										type="text"
										maxLength="20"
										disabled={interviewDetails.editable === false ? true : false}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Issued Date
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<DatePicker
										selected={SelectedFormState.vissaIssuedDate}
										showMonthDropdown
										showYearDropdown
										dateFormat="dd-MMM-yyyy"
										className="form-control z-depth-3"
										dropdownMode="select"
										autoComplete="off"
										placeholderText="dd-mmm-yyyy"
										maxDate={new Date()}
										disabled={interviewDetails.editable === false ? true : false}
										onChange={(date) => dateHandlerString(date, 'vissaIssuedDate')}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Status
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.vissaStatus}
										name="vissaStatus"
										type="text"
										maxLength="100"
										disabled={interviewDetails.editable === false ? true : false}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Date of Expiry
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<DatePicker
										selected={SelectedFormState.visaDateOfExpiry}
										showMonthDropdown
										showYearDropdown
										dateFormat="dd-MMM-yyyy"
										className="form-control z-depth-3"
										dropdownMode="select"
										autoComplete="off"
										placeholderText="dd-mmm-yyyy"
										// maxDate={new Date()}
										disabled={interviewDetails.editable === false ? true : false}
										onChange={(date) => dateHandlerString(date, 'visaDateOfExpiry')}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Comments
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.visaComments}
										name="visaComments"
										type="text"
										maxLength="100"
										disabled={interviewDetails.editable === false ? true : false}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div >
	);
};

export default PassportDetails;
